"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateAnimToken = void 0;
const generateAnimToken = (property, values, easing) => {
  if (Array.isArray(values)) {
    return {
      property,
      fromValue: values[0],
      toValue: values[1],
      easing
    };
  }

  // animate from current value thus no specific fromValue
  return {
    property,
    toValue: values,
    easing
  };
};
exports.generateAnimToken = generateAnimToken;